import React from 'react';
import { useNavigate } from 'react-router-dom';
import './breadcrumbs.css';

interface BreadcrumbsProps {
  to?: string;
  navigateState?: Record<string, unknown>;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ to, navigateState }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (to) {
      navigate(to, navigateState ? { state: navigateState } : undefined);
      return;
    }

    navigate('/');
  };

  return (
    <div className="d-flex justify-content-start space col-6">
      <button
        className="BtnTop yellowTxt btn text-decoration-none backBtn"
        onClick={handleBack}
      >
        Back
      </button>
    </div>
  );
};

export default Breadcrumbs;
